import React from "react";
import { Table, Card, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import Edit from "../../../assets/edit.svg";

function Trainee({ stats, maxmMarks = 2, id }) {
  const navigate = useNavigate();

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: ["userid", "name"],
      key: "name",
      render: (text) => <span style={{ color: "black" }}>{text}</span>,
    },
    {
      title: <span style={{ color: "black" }}>Email Id</span>,
      dataIndex: ["userid", "emailid"],
      key: "emailid",
      render: (text) => <span style={{ color: "black" }}>{text}</span>,
    },
    {
      title: <span style={{ color: "black" }}>Contact No</span>,
      dataIndex: ["userid", "contact"],
      key: "contact",
      render: (text) => <span style={{ color: "black" }}>{text}</span>,
    },
    {
      title: <span style={{ color: "black" }}>Score</span>,
      dataIndex: "score",
      key: "score",
      render: (text) => <span style={{ color: "black" }}>{text}</span>,
    },
    {
      title: <span style={{ color: "black" }}>Max Marks</span>,
      key: "maxMarks",
      render: () => <span style={{ color: "black" }}>{maxmMarks}</span>,
    },
    {
      title: "Details",
      key: "details",
      render: (_, record) => {
        const traineeId = record.userid?._id;
        // console.log(traineeId);

        return (
          <button
            onClick={() =>
              navigate(
                `/trainee/taketest?testid=${id}&traineeid=${traineeId}&isCorrect=true`,
                {
                  state: { isCorrect: true },
                }
              )
            }
            style={{
              background: "transparent",
              border: "none",
              color: "blue",
              display: "flex",
              gap: "8px",
              alignItems: "center",
              cursor: "pointer",
              padding: 0,
            }}
          >
            View Answer Sheet
            <div className="EditBox">
              <img src={Edit} alt="Edit" />
              <div className="progressInfo">
                <Typography.Text className="infoText">
                  Manual Marking: Change the marks of individual questions
                </Typography.Text>
              </div>
            </div>
          </button>
        );
      },
    },
  ];

  return (
    <Card>
      <div className="download-section">
        <Table
          pagination={false}
          rowKey={(record) => record._id}
          columns={columns}
          dataSource={stats}
          style={{ backgroundColor: "#fff", padding: "10px" }}
        />
      </div>
    </Card>
  );
}

export default Trainee;
